import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type PaymentOfferSlice = CommonTableState;

const initialState: PaymentOfferSlice = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: [
            "name",
            "amount",
            "amountTotal",
            "offerType",
            "period",
            "credit",
            "creditPerPeriod",
            "validFrom",
            "validTo",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const paymentOfferSlice = createSlice({
    name: "paymentOffer",
    initialState: initialState,
    reducers: {
        updatePaymentOfferTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updatePaymentOfferTableState } = paymentOfferSlice.actions;

export default paymentOfferSlice.reducer;
